var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { styled } from '@creditas-ui/react';
import { ChevronDownIcon } from '../Icons';
var sizes = {
    sm: '9xl',
    md: '11xl',
};
var IconButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  border-radius: 50%;\n  cursor: pointer;\n  background: none;\n  width: ", ";\n  height: ", ";\n  display: grid;\n  place-content: center;\n\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  border: 0;\n  border-radius: 50%;\n  cursor: pointer;\n  background: none;\n  width: ", ";\n  height: ", ";\n  display: grid;\n  place-content: center;\n\n  :hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, _b = _a.size, size = _b === void 0 ? 'sm' : _b;
    return theme.spacingX[sizes[size]];
}, function (_a) {
    var theme = _a.theme, _b = _a.size, size = _b === void 0 ? 'sm' : _b;
    return theme.spacingX[sizes[size]];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[10];
});
IconButton.defaultProps = {
    children: React.createElement(ChevronDownIcon, null),
};
export default IconButton;
var templateObject_1;
//# sourceMappingURL=IconButton.js.map